const ACTION_PREFIX = '@FORM2/';
export const SET_FORM_DATA = `${ACTION_PREFIX}SET_FORM_DATA`;
export const SET_FORM_ID = `${ACTION_PREFIX}SET_FORM_ID`;
export const SET_CURRENT_PAGE = `${ACTION_PREFIX}SET_CURRENT_PAGE`;
export const PAGE_BACK = `${ACTION_PREFIX}PAGE_BACK`;
export const PAGE_FORWARD = `${ACTION_PREFIX}PAGE_FORWARD`;
export const SET_FIELD_VALUE = `${ACTION_PREFIX}SET_FIELD_VALUE`;
export const SET_DEFAULT_FIELD_VALUE = `${ACTION_PREFIX}SET_DEFAULT_FIELD_VALUE`;
export const SUBMIT_FORM_FOR_VALIDATION = `${ACTION_PREFIX}SUBMIT_FORM_FOR_VALIDATION`;
export const SUBMIT_FORM = `${ACTION_PREFIX}SUBMIT_FORM`;
export const SUBMIT_FORM_SUCCESS = `${ACTION_PREFIX}SUBMIT_FORM_SUCCESS`;
export const SUBMIT_FORM_ERROR = `${ACTION_PREFIX}SUBMIT_FORM_ERROR`;
export const SET_SUBMITTING_FORM = `${ACTION_PREFIX}SET_SUBMITTING_FORM`;
export const SET_ERROR = `${ACTION_PREFIX}SET_ERROR`;
export const VALIDATE_FIELD = `${ACTION_PREFIX}VALIDATE_FIELD`;
export const VALIDATE_PAGE = `${ACTION_PREFIX}VALIDATE_PAGE`;
export const SET_FIELD_ERROR = `${ACTION_PREFIX}SET_FIELD_ERROR`;
export const SET_DATE_RANGE_VALUES = `${ACTION_PREFIX}SET_DATE_RANGE_VALUES`;
export const SET_FORM_ENTRIES = `${ACTION_PREFIX}SET_FORM_ENTRIES`;
export const SET_SUCCESS_MESSAGE = `${ACTION_PREFIX}SET_SUCCESS_MESSAGE`;
export const SET_MULTIPLE_CHECKBOX_VALUE = `${ACTION_PREFIX}SET_MULTIPLE_CHECKBOX_VALUE`;
export const SET_SINGLE_CHECKBOX_VALUE = `${ACTION_PREFIX}SET_SINGLE_CHECKBOX_VALUE`;
export const DO_VALIDATE_FORM = `${ACTION_PREFIX}DO_VALIDATE_FORM`;
